import { NavLink } from "react-router-dom"
import { Home, Calendar, User } from "lucide-react"
import { cn } from "@/lib/utils"
import { buttonVariants } from "@/components/ui/button"

export const AnonSidebar = () => {
  return (
    <div className="border-r bg-gray-100/40 w-[240px] h-full">
      <div className="flex flex-col gap-2 p-4">
        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            cn(
              buttonVariants({ variant: "ghost" }),
              "justify-start",
              isActive && "bg-gray-100"
            )
          }
        >
          <Home className="mr-2 h-4 w-4" />
          Dashboard
        </NavLink>
        <NavLink
          to="/dashboard/events"
          className={({ isActive }) =>
            cn(
              buttonVariants({ variant: "ghost" }),
              "justify-start",
              isActive && "bg-gray-100"
            )
          }
        >
          <Calendar className="mr-2 h-4 w-4" />
          My Events
        </NavLink>
        <NavLink
          to="/dashboard/profile"
          className={({ isActive }) =>
            cn(
              buttonVariants({ variant: "ghost" }),
              "justify-start",
              isActive && "bg-gray-100"
            )
          }
        >
          <User className="mr-2 h-4 w-4" />
          Profile
        </NavLink>
      </div>
    </div>
  )
}
